





























































































































































import { VueConstructor } from 'vue';
import {
	computed,
	defineComponent,
	PropType,
	ref,
} from '@vue/composition-api';
import ColumnContainer from '@front-app/components/layouts/columns/ColumnContainer.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import EditButton from '@front-app/components/buttons/concrete/EditButton.vue';
import EditCommunityAdministratorsModal from '@front-app/views/csr/community/EditCommunityAdministratorsModal.vue';
import EditCommunityNameModal from '@front-app/views/csr/community/EditCommunityNameModal.vue';
import EditCommunityOrganizationModal from '@front-app/views/csr/community/EditCommunityOrganizationModal.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SelectedAdministratorButton from '@front-app/views/csr/community/SelectedAdministratorButton.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import StandardErrorText from '@front-app/components/cards/state/StandardErrorText.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import { CommunityWithGroups } from '@front-app/services/CommunityApi/CommunityModel';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useCommunitiesStore } from '@front-app/store/piniaModules/communities';
import { FocusableElement, useAsyncModal } from '@front-app/hooks/useAsyncModal';
import { FullOrganization } from '@front-app/services/OrganizationsApi/OrganizationModel';
import { Size } from '@front-app/components/constants';
import { UserAccountStatus } from '@front-app/services/UserApi/UserModel';

const loadCreateOrganizationModal = () => import(/* webpackChunkName: "createOrganizationForm" */'@front-app/modules/organization/components/CreateOrganizationForm.vue')
	.then((_) => _.default as VueConstructor);

export default defineComponent({
	components: {
		ColumnContainer,
		CtaButton,
		EditButton,
		EditCommunityAdministratorsModal,
		EditCommunityNameModal,
		EditCommunityOrganizationModal,
		ErrorCard,
		SelectedAdministratorButton,
		SimpleCard,
		SlidingPanel,
		StandardErrorText,
		SuccessCard,
	},
	props: {
		community: {
			type: Object as PropType<CommunityWithGroups>,
			required: false,
			default: null,
		},
	},
	setup(props) {
		const communitiesStore = useCommunitiesStore();

		// Name
		const isEditNamePanelOpen = ref(false);
		const openEditNamePanel = () => {
			isEditNamePanelOpen.value = true;
		};
		// END Name

		// Organization
		const isEditOrganizationPanelOpen = ref(false);
		const openEditOrganizationPanel = () => {
			isEditOrganizationPanelOpen.value = true;
		};
		// END Organization

		// Administrators
		const administrators = computed(() => {
			if (!props.community || !props.community.administrators) {
				return [];
			}
			return props.community.administrators.map((administrator) => ({
				id: administrator.id,
				salutation: administrator.salutation,
				firstName: administrator.firstName,
				middleName: administrator.middleName,
				lastName: administrator.lastName,
				email: '',
				organizationName: '',
				accountStatus: UserAccountStatus.ACTIVATED,
				roles: [],
				specialties: [],
				interests: [],
			}));
		});
		const isEditAdministratorsPanelOpen = ref(false);
		const openEditAdministratorsPanel = () => {
			isEditAdministratorsPanelOpen.value = true;
		};
		// END Administrators

		// Create organization modal
		const {
			isModalVisible: isCreateOrganizationModalOpen,
			modalView: createOrganizationModalView,
			showModal: showCreateOrganizationModal,
			closeModal: closeCreateOrganizationModal,
		} = useAsyncModal('TMP', loadCreateOrganizationModal);
		const initialOrganizationName = ref('');
		const startCreateOrganization = (val: string, returnTo: FocusableElement) => {
			initialOrganizationName.value = val;
			showCreateOrganizationModal(returnTo);
		};
		const handleNewOrganization = (result: FullOrganization) => {
			communitiesStore.saveOrganization(props.community.id, {
				organizationId: result.id,
			});
			closeCreateOrganizationModal();
		};
		// END Create organization modal

		// Activate/deactivate
		const {
			track,
			isError,
			isLoading,
		} = useAsyncStatus();

		const toggleActivate = () => {
			track(communitiesStore.saveCommunityUpdates(props.community.id, { isActive: !props.community.isActive }));
		};
		// END Activate/deactivate

		return {
			// Name
			isEditNamePanelOpen,
			openEditNamePanel,
			// Select Organization
			isEditOrganizationPanelOpen,
			openEditOrganizationPanel,
			// Create Organization
			isCreateOrganizationModalOpen,
			createOrganizationModalView,
			closeCreateOrganizationModal,
			loadCreateOrganizationModal,
			startCreateOrganization,
			handleNewOrganization,
			initialOrganizationName,
			// Administrators
			administrators,
			isEditAdministratorsPanelOpen,
			openEditAdministratorsPanel,
			// Activate/deactivate
			toggleActivate,
			isError,
			isLoading,
			// Util
			Size,
		};
	},
});
